// Touch/pointer device detection. Two-stage:
//   - At boot, sniff the platform for touch capability.
//   - At runtime, upgrade to touch mode the first time we see a real touch
//     pointer event. Hybrid devices (Surface, iPad with mouse) that start
//     as desktop flip to touch as soon as the user touches.
//
// Modules import `isTouchDevice()` for read access. Input handlers call
// `markTouchInput()` from any handler that receives a touch event.

let touchMode = sniffInitialTouch();
const listeners = new Set<() => void>();

function sniffInitialTouch(): boolean {
  if (typeof window === 'undefined') return false;
  if ('ontouchstart' in window) return true;
  const nav = navigator as Navigator & { maxTouchPoints?: number };
  return (nav.maxTouchPoints ?? 0) > 0;
}

export function isTouchDevice(): boolean {
  return touchMode;
}

/** Force touch mode on. Idempotent. Notifies subscribers if the value changed. */
export function markTouchInput(): void {
  if (touchMode) return;
  touchMode = true;
  for (const fn of listeners) fn();
}

/** Subscribe to touch-mode-on transitions. Returns an unsubscribe fn. */
export function onTouchModeChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
